<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Action')">
                <a-input
                  v-decorator="['action', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Type')">
                <a-input
                  v-decorator="['type', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Description')">
                <a-input
                  v-decorator="['description', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>

          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'action',
          tableSetup: {
            tableConfig: {
              rowKey: 'action'
            },
            columns: [
              {title: 'Acción', dataIndex: 'action', sorter: true},
              {title: 'Tipo', dataIndex: 'type', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'action'},
            {name: 'type'},
            {name: 'description'}
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/Action.vue